










import { Component, Prop, Vue } from 'vue-property-decorator';
import { Product } from '@/api';
import InformationRow from '@/components/display/information-row.vue';
import { ProductOrdwayAttributes } from '@/models/ordway';
import BillingSetupButton from '@/components/billing-setup-form/billing-setup-button.vue';

@Component({
	components: { BillingSetupButton, InformationRow },
})
export default class PlanRow extends Vue {
	@Prop({ required: true })
	public currentBilling!: any;
}
